import React from 'react'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  Header: {
    color: theme.palette.primary.main,
  },
  titleText: {
    color: theme.palette.darkGrey.main,
  },
}))

const AuthenticatedCardHeader = ({ title, subtitle }) => {
  const classes = useStyles()
  return (
    <>
      {title && (
        <Typography
          className={clsx(classes.titleText, 'text-center md:w-full text-xl')}
        >
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography
          className={clsx(classes.titleText, 'text-center md:w-full')}
        >
          {subtitle}
        </Typography>
      )}
      {(title || subtitle) && <div className="mb-24"></div>}
    </>
  )
}

AuthenticatedCardHeader.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

export default AuthenticatedCardHeader
